export default "__VITE_ASSET__C_0I$8oE__"